<template>
  <div class="mt-md-3 mx-md-8 mx-lg-16">
    <v-card flat>
      <v-card-title>
        Neue Abrechnung Erzeugen
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row class="mx-0">
          <div style="width: 600px" class="mr-md-12">
            <settlement-editor ref="settlementEditor"> </settlement-editor>
          </div>
        </v-row>
      </v-card-text>
      <v-divider class="mt-3" />
      <v-card-actions>
        <v-btn color="primary" elevation="0" @click="doSubmission()">
          Erstellen
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SettlementEditor from "@/components/financial/SettlementEditor";

export default {
  name: "SettlementSubmission",
  components: { SettlementEditor },
  methods: {
    ...mapActions("financial", ["submitSettlement"]),
    doSubmission() {
      if (this.$refs.settlementEditor.validate()) {
        let newSettlement = this.$refs.settlementEditor.getSettlement();
        this.submitSettlement(newSettlement);
        this.$router.push("/financial/settlements");
      } else {
        this.$vuetify.goTo(1, { duration: 650 });
      }
    }
  },
  computed: {
    ...mapGetters("user", ["isAdmin", "isStavo", "isTreasurer"]),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  }
};
</script>

<style scoped></style>
